module.exports = __webpack_public_path__ + "static/media/beslissen.0d36f5ee.svg";